import React, {useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import KoreanCampaign from '../../../features/page/leaderboard/campaign/KoreanCampaign'
import Text from '../../../components/text/Text'
import EnglishCampaign from '../../../features/page/leaderboard/campaign/EnglishCampaign'
import DateInput from '../../../components/input/DateInput'
import UnderLineInput from '../../../components/input/UnderLineInput'
import WizButton from '../../../components/button/WizButton'
import {useTime} from '../../../utils/time'
import {createCampaign} from '../../../apis/campaign/createCampaign'
import useNavigation from '../../../hooks/useNavigation'

interface IProps {
    className?: string
}

export interface ICreateCampaignState {
    action: string
    action_type: string
    background_color: {
        dark: string
        light: string
    }
    background_image: string
    name: string
}

export interface ICommonState {
    start_at: string | boolean
    end_at: string | boolean
    sorting: number
    language: string
}

const CampaignCreatePage: React.FC<IProps> = ({className}) => {
    const [viewState, setViewState] = useState(['en'])
    const [englishCampaign, setEnglishCampaign] = useState<ICreateCampaignState>()
    const [koreanCampaign, setKoreanCampaign] = useState<ICreateCampaignState>()
    const [commonState, setCommonState] = useState<ICommonState>()

    const {convertInputToTimezone} = useTime()
    const {goCampaign} = useNavigation()

    const onClickChannel = (lang: string) => {
        if (viewState?.find(item => item === lang)) {
            setViewState(viewState?.filter(item => item !== lang))
        } else {
            setViewState([...viewState, lang])
        }
    }

    const getChannelButtonStyle = (lang: string) => {
        if (viewState?.find(item => item === lang)) {
            return 'border-sub_blue bg-sub_blue'
        } else {
            return 'border-line02 bg-white'
        }
    }

    const getChannelTextStyle = (lang: string) => {
        if (viewState?.find(item => item === lang)) {
            return 'text-white'
        } else {
            return 'text-font04'
        }
    }

    const onClickCreateCampaign = async () => {
        if (viewState.length === 0) {
            alert('Create Error')
            return
        }
        if (viewState.length > 1) {
            viewState.map(async lang => {
                const campaignData = lang === 'en' ? englishCampaign : koreanCampaign

                if (
                    !campaignData?.name ||
                    !campaignData?.action ||
                    !campaignData?.action_type ||
                    !campaignData?.background_image ||
                    !campaignData?.background_color.dark ||
                    !campaignData?.background_color.light
                ) {
                    alert(`Please Check Input or Image - Language : ${lang}`)
                    return
                }

                const resBody = {
                    ...campaignData,
                    start_at: convertInputToTimezone(commonState.start_at),
                    end_at: convertInputToTimezone(commonState.end_at),
                    sorting: commonState.sorting,
                    language: lang,
                }
                const {data} = await createCampaign(resBody)

                if (data?.success) {
                    alert(`${lang === 'en' ? 'English Campaign' : 'Korean Campaign'} Create Complete!`)
                    goCampaign()
                } else {
                    alert(`${lang === 'en' ? 'English Campaign' : 'Korean Campaign'} Create Error!`)
                }
            })
        } else if (viewState.at(0) === 'en') {
            if (
                !englishCampaign?.name ||
                !englishCampaign?.action ||
                !englishCampaign?.action_type ||
                !englishCampaign?.background_image ||
                !englishCampaign?.background_color.dark ||
                !englishCampaign?.background_color.light
            ) {
                alert(`Please Check Input or Image`)
                return
            }

            const resBody = {
                ...englishCampaign,
                start_at: convertInputToTimezone(commonState?.start_at),
                end_at: convertInputToTimezone(commonState?.end_at),
                sorting: commonState?.sorting,
                language: 'en',
            }
            const {data} = await createCampaign(resBody)

            if (data?.success) {
                alert(`English Campaign Create Complete!`)
                goCampaign()
            } else {
                alert(`English Campaign Create Error!`)
            }
        } else {
            if (
                !koreanCampaign?.name ||
                !koreanCampaign?.action ||
                !koreanCampaign?.action_type ||
                !koreanCampaign?.background_image ||
                !koreanCampaign?.background_color.dark ||
                !koreanCampaign?.background_color.light
            ) {
                alert(`Please Check Input or Image`)
                return
            }

            const resBody = {
                ...koreanCampaign,
                start_at: convertInputToTimezone(commonState?.start_at),
                end_at: convertInputToTimezone(commonState?.end_at),
                sorting: commonState?.sorting,
                language: 'ko',
            }

            const {data} = await createCampaign(resBody)

            if (data?.success) {
                alert(`Korean Campaign Create Complete!`)
                goCampaign()
            } else {
                alert(`Korean Campaign Create Error!`)
            }
        }
    }

    return (
        <PageLayout title={'Create Bottom Sheet'}>
            <div className={'flex justify-center gap-x-[20px]'}>
                <div
                    onClick={() => onClickChannel('en')}
                    className={`cursor-pointer px-[40px] py-[10px] border rounded-[10px] ${getChannelButtonStyle(
                        'en',
                    )}`}>
                    <Text className={getChannelTextStyle('en')}>English</Text>
                </div>
                <div
                    onClick={() => onClickChannel('ko')}
                    className={`cursor-pointer px-[40px] py-[10px] border rounded-[10px] ${getChannelButtonStyle(
                        'ko',
                    )}`}>
                    <Text className={getChannelTextStyle('ko')}>Korean</Text>
                </div>
            </div>
            <div
                className={
                    'mt-[30px] max-w-[1000px] mx-auto flex gap-[10px] lg:max-w-[900px] md:max-w-[100%] sm:flex-col sm:gap-[60px]'
                }>
                {viewState?.includes('en') && (
                    <EnglishCampaign data={englishCampaign} setData={e => setEnglishCampaign(e)} />
                )}
                {viewState?.includes('ko') && (
                    <KoreanCampaign data={koreanCampaign} setData={e => setKoreanCampaign(e)} />
                )}
            </div>
            <div className={'mt-[30px]'}>
                <div
                    className={
                        'w-[480px] bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[85px] space-y-[40px] sm:w-full sm:px-[40px]'
                    }>
                    <div className={'text-center'}>
                        <Text className={'text-body3 text-font02'}>Start At</Text>
                        <DateInput
                            onChange={e => {
                                setCommonState({...commonState, start_at: e.target.value})
                            }}
                        />
                    </div>
                    <div className={'text-center'}>
                        <Text className={'text-body3 text-font02'}>End At</Text>
                        <DateInput
                            onChange={e => {
                                setCommonState({...commonState, end_at: e.target.value})
                            }}
                        />
                    </div>
                    <div>
                        <Text className={'text-body3 text-font02 '}>Sorting (Order)</Text>
                        <UnderLineInput
                            onChanged={text => {
                                setCommonState({...commonState, sorting: Number(text)})
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className={'mt-[30px] text-center'}>
                <WizButton
                    type={'primary'}
                    size={'big'}
                    text={'Create Campaign'}
                    onClick={() => {
                        onClickCreateCampaign()
                    }}
                />
            </div>
        </PageLayout>
    )
}

export default CampaignCreatePage
